import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base.service';
import { WtpReviewType } from '../models/wtp-review-type';
import { AppConfig } from './app-config';

@Injectable({
  providedIn: 'root'
})
export class WtpReviewTypeService extends BaseService<WtpReviewType> {

  constructor(http: HttpClient, protected appConfig: AppConfig) {
    super(http, appConfig);
  }

  public update(data: any, wtpReviewTypeId: number): Observable<any> {
    const resourceUrl = `${this.getResourceUrl()}/${wtpReviewTypeId}`;
    return this.http.patch(resourceUrl, data);
  }

  public delete(wtpReviewTypeId: number): Observable<any> {
    const resourceUrl = `${this.getResourceUrl()}/${wtpReviewTypeId}`;
    return this.http.delete(resourceUrl);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}/v1/wtp/types`;
  }

}
